module.exports = __webpack_public_path__ + "img/brightness-alt-high.a04a0762.svg";